import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchHistory } from '@/services/history';

export function useHistoryQuery() {
  const { status, session } = useAuthSession();

  return useQuery({
    queryKey: ['history', session?.user.id ?? null],
    queryFn: fetchHistory,
    enabled: status === 'ready',
  });
}
